import { useCallback } from 'react';

import {
  DragAndDropEditorModalType,
  useDragAndDropEditorModalsContext,
} from 'modules/dragAndDropEditor/context';
import { ManageMessageCategoriesVariables } from 'modules/dragAndDropEditor/hooks/useManageMessageCategories';
import { useUpsertMessageCategories } from 'modules/dragAndDropEditor/hooks/useUpsertMessageCategories';
import noop from 'utils/noop';

export const useProcessCategoriesUpsert = () => {
  const { closeModal } = useDragAndDropEditorModalsContext();
  const { upsertMessageCategories, isLoading } = useUpsertMessageCategories();

  const processMessageCategoriesUpsert = useCallback(
    (variables: ManageMessageCategoriesVariables, onClose = noop) => {
      upsertMessageCategories({
        variables,
        onCompleted: (data) => {
          // If the data has the failure field, it means the upsert failed
          if (!data?.manageMessageCategories?.failure) {
            closeModal(DragAndDropEditorModalType.ManageCustomCategories);
            onClose();
          }
        },
      });
    },
    [closeModal, upsertMessageCategories],
  );

  return { isLoading, processMessageCategoriesUpsert };
};
